import React from "react";
import CultureDropdown from "./CultureDropdown";
import { type DropdownWithoutOptionsProps } from "../models";

const CulturesTemplateDropdown = (props: DropdownWithoutOptionsProps<server.dto.LCID, server.dto.LCID>) => {
  const options = serverReference.cultures;
  const value = options.find(c => c.value === props.value);

  return <CultureDropdown
    excludeKeys={props.excludeKeys}
    value={value}
    onChange={(culture) => props.onChange(culture.value)}
    onEsc={props.onEsc}
    options={options}
    config={{
      isSearchable: true,
      ...props.config
    }}
  />;
};

export default CulturesTemplateDropdown;